import 'react-native-gesture-handler';
import React from 'react';

import Callback from '@pages/Callback';
import InvoiceDetail from '@pages/InvoiceDetail';
import Main from '@pages/Main';
import PostingInvoices from '@pages/PostingInvoices';
import Robot from '@pages/Robot';
import { createStackNavigator } from '@react-navigation/stack';

const App = createStackNavigator();

const commonScreens = {
  Callback,
  Robot
};

const userScreens = {
  InvoiceDetail,
  Main,
  PostingInvoices
};

interface AppRoutesProps {
  isLoggedIn: boolean;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ isLoggedIn }) => {
  return (
    <App.Navigator
      initialRouteName={isLoggedIn ? 'Main' : 'Callback'}
      screenOptions={{
        headerShown: false,
        cardStyle: {
          backgroundColor: '#F2F2F2',
          flex: 1
        },
        cardOverlayEnabled: true
      }}
    >
      {Object.entries({
        ...commonScreens,
        ...(isLoggedIn ? userScreens : [])
      }).map(([name, component]) => (
        <App.Screen key={name} name={name} component={component} />
      ))}
    </App.Navigator>
  );
};

export default AppRoutes;
